const API_URL = process.env.REACT_APP_API_BASE_URL || 'http://169.58.21.41/api';

const getHeaders = () => ({
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${localStorage.getItem('auth_token')}`
});

export const sensorService = {
    ensureAuth: async () => {
        if (!localStorage.getItem('auth_token')) {
            throw new Error("Veritabanı erişim yetkisi alınamadı. Lütfen giriş yapın.");
        }
    },

    subscribeToSensor: (sensorId, callback) => {
        // No real-time support — poll every 30 seconds
        const fetchData = async () => {
            try {
                const res = await fetch(`${API_URL}/sensors/${sensorId}`, { headers: getHeaders() });
                if (res.ok) {
                    const data = await res.json();
                    callback({ latestData: { havaSicaklik: data.latestValue }, lat: data.lat, lng: data.lng });
                }
            } catch (e) {
                console.error('Sensor subscribe error:', e);
            }
        };
        fetchData();
        const interval = setInterval(fetchData, 30000);
        return () => clearInterval(interval);
    },

    getAllSensorsLatest: async () => {
        const res = await fetch(`${API_URL}/sensors`, { headers: getHeaders() });
        if (!res.ok) return [];
        const sensors = await res.json();
        return sensors.map(s => ({
            sensorId: String(s.id),
            id: s.id,
            lat: s.lat,
            lng: s.lng,
            fieldId: s.fieldId,
            name: s.name,
            type: s.type,
            apiKeyName: s.apiKeyName || null,
            insighioDeviceId: s.insighioDeviceId || null,
            insighioChannel: s.insighioChannel || null,
            fieldclimateStationId: s.fieldclimateStationId || null,
            fieldclimateTzOffsetMin: s.fieldclimateTzOffsetMin ?? null,
            lastUpdate: s.lastUpdate || null,
            sensorType: s.sensorType || null,
            latestValue: s.latestValue ?? null,
            // latestData: DB'den gelen gerçek ölçüm objesi + legacy fallback key'ler
            latestData: {
                ...(s.latestData && typeof s.latestData === 'object' ? s.latestData : {}),
                // legacy key'ler — eski sensör tipleri için
                havaSicaklik: s.type === 'Temperature' ? s.latestValue : (s.latestData?.Temperature ?? s.latestData?.['A.Temperature'] ?? undefined),
                havaNem:      s.type === 'Humidity'    ? s.latestValue : (s.latestData?.R_Humidity ?? s.latestData?.board_humidity ?? undefined),
                toprakSicaklik: s.latestData?.['S.Temperature_15cm'] ?? (s.type === 'SoilTemperature' ? s.latestValue : undefined),
                toprakNem:      s.latestData?.VWC_15cm ?? (s.type === 'Moisture' ? s.latestValue : undefined),
            }
        }));
    },

    getSensorHistory: async (sensorId, limit = 50) => {
        try {
            const res = await fetch(
                `${API_URL}/sensors/${sensorId}/history?limit=${limit}`,
                { headers: getHeaders() }
            );
            if (!res.ok) return [];
            return await res.json();
        } catch {
            return [];
        }
    },

    addSensor: async (sensorId, sensorData) => {
        const res = await fetch(`${API_URL}/sensors`, {
            method: 'POST',
            headers: getHeaders(),
            body: JSON.stringify({
                name: `Sensör ${sensorId}`,
                type: 'Temperature',
                lat: sensorData.lat || 0,
                lng: sensorData.lng || 0,
                fieldId: sensorData.fieldId || null,
                latestValue: sensorData.latestData?.havaSicaklik || null
            })
        });
        if (!res.ok) throw new Error('Sensör eklenemedi');
        return res.json();
    },

    updateSensorData: async (sensorId, data) => {
        const res = await fetch(`${API_URL}/sensors/${sensorId}`, {
            method: 'PUT',
            headers: getHeaders(),
            body: JSON.stringify({ latestValue: data.havaSicaklik || data.latestValue })
        });
        if (!res.ok) throw new Error('Sensör güncellenemedi');
        return res.json();
    },

    updateSensorLocation: async (sensorId, location) => {
        const res = await fetch(`${API_URL}/sensors/${sensorId}`, {
            method: 'PUT',
            headers: getHeaders(),
            body: JSON.stringify({ lat: location.lat, lng: location.lng, fieldId: location.fieldId })
        });
        if (!res.ok) throw new Error('Konum güncellenemedi');
        return res.json();
    },

    batchUpdateSensorLocations: async (sensors) => {
        await Promise.all(sensors.map(sensor =>
            fetch(`${API_URL}/sensors/${sensor.sensorId}`, {
                method: 'PUT',
                headers: getHeaders(),
                body: JSON.stringify({ lat: sensor.lat, lng: sensor.lng, fieldId: sensor.fieldId })
            })
        ));
    },

    checkConnection: async () => {
        try {
            const res = await fetch(`${API_URL}/sensors`, { headers: getHeaders() });
            return { success: res.ok };
        } catch (error) {
            return { success: false, error: error.message };
        }
    }
};
